import axios from 'axios';
import { getNonGwApiRoot, getApiRoot } from '../../../constants/ParamountReactConstants';

const CancelToken = axios.CancelToken;

let fetchAccountCustomFieldsCancelToken: any;
let fetchAccountCustomFieldGroupsCancelToken: any;
let fetchCustomFieldsBrandsCancelToken: any;
let updateCustomFieldToBrandsCancelToken: any;
let fetchAccountCustomFieldUsesCancelToken: any;

export function fetchAccountCustomFields() {
  if (fetchAccountCustomFieldsCancelToken) fetchAccountCustomFieldsCancelToken();

  return {
    type: 'FETCH_ACCOUNT_CUSTOM_FIELDS',
    payload: axios.get(`${getApiRoot()}/accounts/custom_fields`, {
      cancelToken: new CancelToken(c => {
        fetchAccountCustomFieldsCancelToken = c;
      }),
    }),
  };
}

export function fetchAccountCustomFieldGroups() {
  if (fetchAccountCustomFieldGroupsCancelToken) fetchAccountCustomFieldGroupsCancelToken();

  return {
    type: 'FETCH_ACCOUNT_CUSTOM_FIELD_GROUPS',
    payload: axios.get(`${getApiRoot()}/accounts/custom_fields/groups`, {
      cancelToken: new CancelToken(c => {
        fetchAccountCustomFieldGroupsCancelToken = c;
      }),
    }),
  };
}

export function fetchAccountCustomFieldUses() {
  if (fetchAccountCustomFieldUsesCancelToken) fetchAccountCustomFieldUsesCancelToken();

  return {
    type: 'FETCH_ACCOUNT_CUSTOM_FIELD_USES',
    payload: axios.get(`${getNonGwApiRoot()}/accounts/custom_fields/uses`, {
      cancelToken: new CancelToken(c => {
        fetchAccountCustomFieldUsesCancelToken = c;
      }),
    }),
  };
}

export function fetchCustomFieldsBrands() {
  if (fetchCustomFieldsBrandsCancelToken) fetchCustomFieldsBrandsCancelToken();

  return {
    type: 'FETCH_CUSTOM_FIELDS_BRANDS',
    payload: axios.get(`${getApiRoot()}/accounts/custom_fields/custom_fields_to_brands`, {
      cancelToken: new CancelToken(c => {
        fetchCustomFieldsBrandsCancelToken = c;
      }),
    }),
  };
}

export function updateCustomFieldToBrands(payload: {
  custom_field_to_brands: Array<{ custom_field_id: number; brand_ids: number[] }>;
}) {
  if (updateCustomFieldToBrandsCancelToken) updateCustomFieldToBrandsCancelToken();

  return {
    type: 'UPDATE_CUSTOM_FIELD_TO_BRANDS',
    payload: axios.patch(
      `${getApiRoot()}/accounts/custom_fields/update_custom_field_to_brands`,
      payload,
      {
        cancelToken: new CancelToken(c => {
          updateCustomFieldToBrandsCancelToken = c;
        }),
      }
    ),
  };
}

// Local state management actions
export function setPendingBrandChanges(customFieldId: number, brandIds: number[]) {
  return {
    type: 'SET_PENDING_BRAND_CHANGES',
    payload: { customFieldId, brandIds },
  };
}

export function setPendingBrandChangesForAllFields(fieldToBrandMapping: Record<number, number[]>) {
  return {
    type: 'SET_PENDING_BRAND_CHANGES_BATCH',
    payload: { fieldToBrandMapping },
  };
}

export function clearPendingChanges() {
  return {
    type: 'CLEAR_PENDING_CHANGES',
  };
}

// Keep the old function for backwards compatibility if needed
export function fetchParentCustomFields() {
  return {
    type: 'FETCH_PARENT_CUSTOM_FIELDS',
    payload: axios.get(`${getApiRoot()}/parents/custom_fields`),
  };
}
